import {MessageTemplateEntity} from "../../../proto/generated/api_entities_pb";
import {IMessageTemplate} from "./messageTemplatesReducerTypes";

export const mapMessageTemplateEntityToIMessageTemplate = (item: MessageTemplateEntity): IMessageTemplate => {
  return {
    id: item.getMessagetemplateid(),
    userId: item.getUserid(),
    name: item.getName(),
    text: item.getText(),
    dateAdded: item.getDateadded(),
    dateModified: item.getDatemodified(),
  }
}

